<template>
  <WsUpdate
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    titleKey="last_version.name"
  >
  </WsUpdate>
</template>

<script>
import model from "@/models/checklist_conclusion_daily_template";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              fields: ["last_version"],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              fields: [
                "sequence",
                "area",
                "system_class",
                "system_subclasses",
                "industry_categories",
              ],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              remark: "隱藏的內容將不會顯示於使用者前台介面",
              fields: ["is_active"],
            },
          ],
        },
      ],
    },
  }),
};
</script>